import clsx from 'clsx';
import { observer } from 'mobx-react-lite';

import TriangleIcon from 'src/shared/assets/icons/insertion-triangle.svg';

import type { Range } from '../../../../../layers/model';
import type {
  WellRigOperation,
  InsertionPoint as InsertionPointEntity,
} from '../../../../../presets/drilling-rigs-chart/entities';
import { useMovableElement } from '../../../../../shared/use-movable-element';
import type { UseDroppable } from '../../hooks/use-droppable';
import { useDroppable } from '../../hooks/use-droppable';

import styles from './insertion-point.module.scss';

interface Props {
  item: InsertionPointEntity<WellRigOperation>;
  horizontalViewport: Range<number>;
  verticalViewport: Range<number>;
}

const options: UseDroppable.Options = {
  overClassname: styles.over,
};

export const InsertionPoint = observer(function InsertionPoint({ item, horizontalViewport, verticalViewport }: Props) {
  const ref = useMovableElement({ item, horizontalViewport, verticalViewport });

  useDroppable({
    id: item.getKey('droppable'),
    dataItem: item,
    nodeRef: ref,
    options,
  });

  return (
    <div
      ref={ref}
      className={clsx(
        styles.container,
        !item.isAvailable && styles.notAvailable,
        item.expandLeft && styles.expandedLeft,
        item.expandRight && styles.expandedRight,
      )}
    >
      <div className={styles.rect}>
        <TriangleIcon className={styles.arrow} />
        <TriangleIcon className={styles.arrowUp} />
      </div>
    </div>
  );
});
